import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY, USER_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
    const [error, setError] = useState("");

    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) { setUser(false); return; }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            localStorage.setItem(USER_KEY, JSON.stringify(data));
        } catch {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
            setUser(false);
        }
    }, []);

    useEffect(() => { bootstrap(); }, [bootstrap]);

    const handleAuth = async (path, payload) => {
        setError("");
        try {
            const { data } = await api.post(path, payload);
            localStorage.setItem(TOKEN_KEY, data.token);
            localStorage.setItem(USER_KEY, JSON.stringify(data.user));
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            const d = e?.response?.data?.detail;
            const msg = typeof d === "string" ? d : (Array.isArray(d) ? d.map(x => x.msg || JSON.stringify(x)).join(" ") : "Authentication failed");
            setError(msg);
            return { ok: false, error: msg };
        }
    };

    const login = (email, password) => handleAuth("/auth/login", { email, password });
    const register = (email, password, name) => handleAuth("/auth/register", { email, password, name });

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        setUser(false);
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, login, register, logout, error, setError, refresh: bootstrap }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
